import { Fragment } from 'react';
import logo from '../assets/images/arhiv360-logo.jpeg';
import { Bars3Icon, ChevronDownIcon } from '@heroicons/react/24/outline';
import { useNavigate } from 'react-router-dom';
import { Menu, Transition } from '@headlessui/react';
import { classNames } from '../common/utils/utils';
import i18n from '../common/config/i18n';
import { supabase } from '../common/config/supabase';
import { useUserProfile } from '../contexts/user/UserContext';
import { APP_VERSION } from '../common/constants/version';

interface HeaderProps {
  openSlidingMenu: (isOpen: boolean) => void;
}

const Header = ({ openSlidingMenu }: HeaderProps) => {
  const { user } = useUserProfile();
  const navigate = useNavigate();

  const onNavigate = (route: string): void => navigate(route);

  const logout = async () => {
    await supabase.auth.signOut();
  };
  return (
    <header className={classNames('bg-white h-[4.5rem] py-2 px-4 md:px-10')}>
      <nav className="w-full flex justify-between items-center">
        <div className="flex gap-4 w-fit">
          {user && (
            <div className="flex xl:hidden items-center">
              <button
                id="side_menu-open-btn"
                aria-label="Menu"
                className="flex items-center gap-4 hover:bg-green-tab py-2 px-2 rounded-xl focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-100 focus:ring-indigo-500"
                onClick={openSlidingMenu.bind(null, true)}
              >
                <Bars3Icon className="w-5 h-5" />
              </button>
            </div>
          )}
          <div className="flex items-center">
            <img
              src={logo}
              alt="Arhiv360_logo"
              className="md:w-60 cursor-pointer mr-4"
              id="logo__header"
              onClick={onNavigate.bind(null, `/`)}
            />
            <p className="text-blue">Adeverinte</p>
          </div>
        </div>
        {user && (
          <div className="flex space-x-4 items-center z-10">
            <Menu as="div" className="relative inline-block text-left">
              <div>
                <Menu.Button
                  id="account_menu__open-btn"
                  className="flex items-center md:gap-4 hover:bg-green-tab sm:py-2 sm:px-4 py-1 px-2 rounded-xl focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-100 focus:ring-indigo-500"
                >
                  <div className="flex justify-center rounded-full bg-cover object-cover aspect-square w-10 bg-sky-500 text-white">
                    <p className="self-center">{user?.email && user?.email[0]}</p>
                  </div>
                  <h4 className="tracking-wide text-right">{user?.email || ''}</h4>
                  <ChevronDownIcon className="w-5 h-5 md:w-6 md:h-6 text-gray-900" />
                </Menu.Button>
              </div>
              <Transition
                as={Fragment}
                enter="transition ease-out duration-100"
                enterFrom="transform opacity-0 scale-95"
                enterTo="transform opacity-100 scale-100"
                leave="transition ease-in duration-75"
                leaveFrom="transform opacity-100 scale-100"
                leaveTo="transform opacity-0 scale-95"
              >
                <Menu.Items className="origin-top-right absolute right-0 mt-2 w-56 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 focus:outline-none">
                  <div className="flex flex-col divide divide-y divide-cool-gray-200">
                    <div className="py-2">
                      <Menu.Item>
                        {({ active }: any) => (
                          <a
                            id="logout__menu-item"
                            aria-label="logout"
                            className={classNames(
                              active ? 'bg-gray-100' : '',
                              'group flex items-center justify-center px-4 py-2 text-red-600 hover:text-red-500',
                            )}
                            onClick={logout}
                          >
                            <p>{i18n.t('header:menu.options.logout')}</p>
                          </a>
                        )}
                      </Menu.Item>
                    </div>
                    <small className="py-4 text-cool-gray-500 self-center">
                      {i18n.t('general:version')} {APP_VERSION}
                    </small>
                  </div>
                </Menu.Items>
              </Transition>
            </Menu>
          </div>
        )}
      </nav>
    </header>
  );
};

export default Header;
